import { Alert, Box, Button, ButtonGroup, Checkbox, IconButton, InputLabel, Modal, Paper, SpeedDial, SpeedDialAction, SpeedDialIcon, TextField, Tooltip} from "@mui/material";
import PDFImage from "../../assets/PDF_Image.png";
import PowerPointImage from "../../assets/PowerPoint_Image.png"
import Unknow from "../../assets/Unknow.png"
import VideoIcon from "../../assets/VideoIcon.png"

import { Add, Clear, Close, Save, Search, Upload } from "@mui/icons-material";
import { useEffect, useRef, useState } from "react";
import Swal from "sweetalert2"
import axios from "axios";
import { Url } from "../../constants";
import { useNavigate } from "react-router-dom";
import Loader from "../../Layout/Loader/Loaders";

const Descargas = () => {

    const token = localStorage.getItem("token")
    const modulo_prop = JSON.parse(localStorage.getItem("modulo"))
    const user_datos = JSON.parse(localStorage.getItem("user"))
    const [isCharging, setisCharging] = useState(false)
    const [permisos, setpermisos] = useState([])
    const Navigate = useNavigate()

    const [archivos, setarchivos] = useState([])
    const [tipo_archivos, settipo_archivos] = useState([])

    const getFiles = async () => {
        setisCharging(true)

        await axios.get(Url + "GetArchivos?modulo="+modulo_prop.id_modul, {
            headers:{
                Authorization: token
            }
        })
        .then(res => {
            setisCharging(false)
            setarchivos(res.data.Archivos ? res.data.Archivos : res.data)
        })
        .catch(err => {
            setisCharging(false)
            console.log(err)
        })
    }

    const getTypeFiles = async () => {
        setisCharging(true)
        const tipo = "Tipo Archivo"

        await axios.get(Url + "TiposArchivos?modulo="+modulo_prop.id_modul, {
            headers:{
                Authorization: token
            }
        })
        .then(res => {
            settipo_archivos(res.data[tipo])
            setisCharging(false)
        })
        .catch(err => {
            setisCharging(false)
            Swal.fire("Ocurrió un error al cargar los archivos","","error")
            settipo_archivos([])
            console.log(err)
        })
    }

    const getPantallasbyRol = async () => {
        await axios.get(Url + "GetRol?id=" + user_datos.roluser_id, {
            headers: {
                Authorization: token
            }
        })
        .then(res => {
            if (res.data.length > 0) {
                const resultado = res.data.find(obj => obj.pantalla.pantalla === "Archivos");
                setpermisos(resultado.permisos)
            }
        })
        .catch(err => {
            console.log(err)
        })
    }

    useEffect(() => {
        if (token && !["null", "undefined"].includes(token)) {
            getFiles()
            getTypeFiles()
            getPantallasbyRol()
        } else {
            localStorage.clear()
            Navigate("/login")
        }
    },[])

    const [buttonClicked, setbuttonClicked] = useState("")
    const [datoexacto, setdatoexacto] = useState("")
    
    //Add File
    const [showModal, setshowModal] = useState(false)
        const [nameFile, setnameFile] = useState("")
        const inputhidden = useRef(null)
        const [invalido, setinvalido] = useState(false)
        const [exceso_size, setexceso_size] = useState(false)
        const [newfiles, setnewfiles] = useState([])
    //Delete file(s)
    const [showChecksDelete, setshowCheckDelete] = useState(false)
        const [deletedfiles, setdeletefiles] = useState([])

    //Funciones
    const handleChange = (event) => {
        setdatoexacto(event.target.value)
    }
    const pressEnter = (event) => {
        if (event.keyCode === 13) {
            searchDato()
        }
    }
    const searchDato = async () => {
        setisCharging(true)

        await axios.get(Url + "TiposArchivos?modulo="+modulo_prop.id_modul+"&busqueda="+datoexacto, {
            headers:{
                Authorization: token
            }
        })
        .then(res => {
            setarchivos(res.data.Archivos ? res.data.Archivos : res.data)
            setisCharging(false)
        })
        .catch(err => {
            setisCharging(false)
            console.log(err)
        })
    }

    const changeButtonClicked = async (type_extension) => {
        setisCharging(true)

        await axios.get(Url + "TiposArchivos?modulo="+modulo_prop.id_modul+"&tipo_archivo="+type_extension, {
            headers:{
                Authorization: token
            }
        })
        .then(res => {
            setarchivos(res.data.Archivos ? res.data.Archivos : res.data)
            setisCharging(false)
        })
        .catch(err => {
            console.log(err)
            setisCharging(false)
        })

        setbuttonClicked(type_extension)
    }

    //Funciones para poder Agregar uno o más Archivos
    const handleClickButtonPlus = () => {
        setshowModal(true)
        setshowCheckDelete(false)
        setdeletefiles([])
    }

        const clickFile = () => {
            inputhidden.current.click()
        }

        const submitNewFile = async (event) => {

            setexceso_size(false)
            if (event.target.files.length) {
                const array_files = Array.from(event.target.files)
                const array_new_files = []
                //
                let nombres = ""

                for (const [index_file, file_element] of array_files.entries()) {
                    if (index_file === 0) {
                        nombres += file_element.name
                    } else {
                        nombres += ", " + file_element.name
                    }

                    const index_slice = file_element.name.lastIndexOf(".")
                    const name = file_element.name.slice(0, index_slice)
                    const type = file_element.name.slice(index_slice + 1)

                    if (Math.floor(file_element.size / 1000000) > 50) {
                        setexceso_size(true)
                        return
                    } else {
                        array_new_files.push({"name": name, "type": type, "file_prop": file_element})
                    }
    
                };

                setnewfiles(array_new_files)
                setnameFile(nombres)
                setinvalido(false)
            } else {
                setnameFile("")
                setinvalido(true)
            }
        }

        const saveFile = async () => {
            cerrarModal()
            setisCharging(true)

            try {
                await Promise.all(
                    newfiles.map(async (file) => {
                        const formDataNew = new FormData();
                        formDataNew.append("tipo_archivo", file.type);
                        formDataNew.append("nombre_archivo", file.name);
                        formDataNew.append("catalogo_modulo", modulo_prop.id_modul);
                        formDataNew.append("archivo", file.file_prop)
    
                        await axios.post(Url + "SubirArchivo", formDataNew, {
                            headers:{
                                'Content-Type': 'multipart/form-data',
                                Authorization: token
                            }
                        })
                        .catch(err => {console.log(err)})
                    })
                );
                
                Swal.fire("Archivos subidos correctamente","","success")
                getFiles()
                getTypeFiles()
            } catch (error) {
                Swal.fire("Error al cargar un archivo","","error")
            }

        }

    const cerrarModal = () => {
        setnameFile("")
        setshowModal(false)
        setexceso_size(false)
        setinvalido(false)
    }

    //Descargar Archivos
    const DownloadFile = async (file_name, file_id) => {
        setisCharging(true)
        try {
            const response = await axios.get(Url+"DownloadArchivo/"+file_id, {
              responseType: "blob",
              headers: {
                Authorization: token
              }
            }).catch(err => {
                console.log(err)
            });
        
            const blob = new Blob([response.data], { type: response.headers["content-type"] });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = file_name; // Nombre dinámico del archivo
            document.body.appendChild(link);
            link.click();

            setisCharging(false)
            URL.revokeObjectURL(link.href);
            document.body.removeChild(link);


          } catch (error) {
            setisCharging(false)
            Swal.fire("Error al descargar el archivo", "", "error");
            console.error("Error al descargar el archivo:", error);
          }
    }

    //Funciones para eliminar uno más archivos
    const deletefile = () => {
        setshowCheckDelete(!showChecksDelete)
        if (showChecksDelete) {
            setdeletefiles([])
        }
    }
        const handleAll = (event) => {
            const allarray = []

            if (event.target.checked) {
                archivos.map((element) => (
                    allarray.push(element.id)
                ))

                setdeletefiles(allarray)
            } else {
                setdeletefiles([])
            }
        }

        const handleChangeCheckBoxFiles = (event) => {
            const copydeletedfiles = [...deletedfiles]
            const value = parseInt(event.target.value)

            if (copydeletedfiles.length >= 0) {
                if (event.target.checked) {
                    copydeletedfiles.push(value)
                } else {
                    copydeletedfiles.splice(copydeletedfiles.indexOf(value),1)
                }
                setdeletefiles(copydeletedfiles)
            }
        }

        const eraseallfiles = async () => {
            setisCharging(true)

            try {
                await Promise.all(
                    deletedfiles.map((deleted_file) => (
                        axios.delete(Url + "DeleteArchivo/" + deleted_file, {
                            headers: {
                                Authorization: token
                            }
                        })
                    ))
                )
                Swal.fire("Archivos eliminados correctamente","","success")
                setshowCheckDelete(false)
                setdeletefiles([])
                getFiles()
                getTypeFiles()
            }
            
            catch (error) {
                Swal.fire("Ocurrió un error al eliminar el archivo","","error");
            }
        }

    //Estilos#8e44ad
    const cambioByExtension = (extension) => {
        if (extension === "pdf") {
            return {
                "imagen" : PDFImage,
                "border" : "1px solid red",
                "ancho"  : "80px"
            }  
        } else if (extension === "pptx") {
            return {
                "imagen" : PowerPointImage,
                "border" : "1px solid #e67e22",
                "ancho"  : "80px"
            }
        } else if (extension === "mp4") {
            return {
                "imagen" : VideoIcon,
                "border" : "1px solid #8e44ad",
                "ancho"  : "80px"
            }
        }
        else if (["png","jpg","JPG","JPEG","webp"].includes(extension)) {
            return {
                "border" : "1px solid #3498db",
            }
        } else {
            return {
                "imagen" : Unknow,
                "border" : "1px solid gray",
                "ancho"  : "72px"
            }
        }
    }

    const colorType = (type) => {
        if (type === "pdf") {
            return {
                fondo: "error",
                color_claro: "#f1948a",
            }  
        } else if (type === "pptx") {
            return {
                fondo: "error",
                color_claro: "#f1948a",
            }
        } else if (["png","jpg","JPG","JPEG","webp"].includes(type)) {
            return {
                fondo: "primary",
                color_claro: "#85c1e9",
            }
        } else if (type === "mp4") {
            return {
                fondo: "secondary",
                color_claro: "#d2b4de",
            }
        } else {
            return {
                fondo: "#bb8fce",
                color_claro: "gray",
            }
        }
    }
    const quitarExtension = (nombre_param) => {
        return (nombre_param.slice(0, nombre_param.lastIndexOf(".")))
    }

    return (
        <>
            <Box sx={{m:"20px 10px 10px 10px", justifyContent:"space-between", alignItems:"center", 
                display:"flex"}}>
                <TextField placeholder="Buscar..." sx={{width:"20%"}} size="small" onChange={handleChange}
                value={datoexacto} slotProps={{input:{endAdornment:(
                    <>
                    <Tooltip title="Buscar" arrow>
                        <IconButton size="small" onClick={searchDato}><Search/></IconButton>
                    </Tooltip>
                    <Tooltip title="Limpiar" arrow>
                        <IconButton size="small" onClick={()=> {
                            setdatoexacto("");
                            getFiles();
                        }}><Close/></IconButton>
                    </Tooltip>
                    </>
                )}}} onKeyDown={pressEnter}/>

                <h1 style={{marginLeft:"-8%"}}>{modulo_prop.name_modul}</h1>

                <ButtonGroup size="small">
                    <Tooltip title="Quitar filtros" arrow>
                        <IconButton color="error" onClick={() => 
                        {
                            getFiles()
                            setbuttonClicked(" ")
                        }}>
                            <Clear fontSize="small"/>
                        </IconButton>
                    </Tooltip>

                    {tipo_archivos.map((type, index_type) => (
                        <Button color={colorType(type.tipo_archivo).fondo} onClick={() => changeButtonClicked(type.tipo_archivo)} 
                        key={index_type}
                        sx={{backgroundColor: buttonClicked === type.tipo_archivo && colorType(type.tipo_archivo).color_claro,
                            color: buttonClicked === type.tipo_archivo && "white"
                        }}>
                        {type.tipo_archivo}</Button>
                    ))}
                    
                </ButtonGroup>
            </Box>
            
            {showChecksDelete &&
                <Box sx={{display:"flex", alignItems:"center", gap:5, mt:1, ml:2, position:"sticky", 
                    zIndex:1, backgroundColor:"white", top:10, width:"20%"
                }}>
                    <div>
                        <Checkbox onChange={handleAll}/>
                        <label>Seleccionar Todos</label>
                    </div>
                    <Button variant="contained" color="error" disabled={deletedfiles.length === 0}
                    size="small" onClick={eraseallfiles}>
                        Eliminar</Button>
                </Box>
            }

            <Box sx={{display:"flex", gap:7, padding:"30px", width:"calc(100% - 10px)", flexWrap:"wrap", 
            flex:1, overflowY:"auto"}}>
                {archivos.length > 0 &&
                archivos.map((archivo, index_archivo) => (
                    <div key={index_archivo}>
                        {showChecksDelete &&
                            <Checkbox size="small" onChange={handleChangeCheckBoxFiles} value={archivo.id}
                            checked={deletedfiles.includes(archivo.id) ? true : false}/>
                        }
                        <Button sx={{width: "190px", border: cambioByExtension(archivo.tipo_archivo).border}}
                        disabled={showChecksDelete} onClick={() => DownloadFile(archivo.nombre_archivo, archivo.id)}>
                            <Tooltip title={quitarExtension(archivo.nombre_archivo)+"."+ archivo.tipo_archivo} 
                            arrow
                            PopperProps={{
                                sx: {
                                    '& .MuiTooltip-tooltip': {
                                        maxWidth: 200,
                                    },
                                },
                            }}>
                                <div>
                                    <img 
                                    src=
                                    {["JPG","jpg","png","webp"].includes(archivo.tipo_archivo) ? 
                                        archivo.ruta
                                        :
                                        cambioByExtension(archivo.tipo_archivo).imagen
                                    } 
                                    alt="Logo_tipoarchivo" 
                                    width=
                                    {["JPG","jpg","png","webp"].includes(archivo.tipo_archivo) ?    
                                        "auto"
                                        :
                                        cambioByExtension(archivo.tipo_archivo).ancho

                                    }
                                    height={"90px"}
                                    draggable={false}
                                    style={{pointerEvents:"none"}}
                                    />
                                    <InputLabel sx={{fontSize:"12px", whiteSpace:"normal", fontWeight:"bold"}}>
                                        {quitarExtension(archivo.nombre_archivo)}.{archivo.tipo_archivo}
                                    </InputLabel>
                                </div>
                            </Tooltip>
                        </Button>
                    </div>

                ))
                }
            </Box>

            

            {(permisos.includes("crear") || permisos.includes("eliminar")) &&
                <SpeedDial sx={{ position:'absolute', ml:"95%", bottom:20, mt:"-10%" }} icon={<SpeedDialIcon />} 
                ariaLabel="SpeedDial basic example" FabProps={{sx:{mt:-2}}}>
                    {permisos.includes("crear") &&
                        <SpeedDialAction icon={<Add sx={{color:"white"}}/>} tooltipTitle={"Agregar"} 
                        sx={{backgroundColor:"#229954"}} onClick={handleClickButtonPlus} arrow/>
                    }
                    {permisos.includes("eliminar") &&
                        <SpeedDialAction icon={<Close sx={{color:"white"}} fontSize="small"/>} tooltipTitle={"Eliminar"} 
                        sx={{backgroundColor:"red"}} onClick={deletefile} arrow/>
                    }
                </SpeedDial>
            }

            <Modal open={showModal} onClose={cerrarModal} 
            sx={{display:"flex", justifyContent:"center", alignItems:"center"}}>
                <Paper sx={{width:"50%", p:2}}>
                    <input type="file" ref={inputhidden} style={{display:"none"}} 
                    accept=".pdf, .pptx, .jpg, .png, .webp, .mp4"
                    onChange={submitNewFile} multiple/>
                        <div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                            <label>Seleccione un archivo</label>
                            <Button color="error" size="small" variant="outlined" onClick={cerrarModal}>
                                <Close fontSize="small" />
                            </Button>
                        </div>

                        <Box  sx={{my:2, display:"flex", justifyContent:"space-between"}}>
                            <Button variant="contained" endIcon={<Upload />} onClick={clickFile} size="small"
                                sx={{mr:2, height:"35px"}}>
                                Cargar Archivo</Button>
                            
                            
                            <label style={{width:"60%"}}>{nameFile}</label>

                            <Button endIcon={<Save />} variant="contained" color="success" disabled={!nameFile}
                            size="small" onClick={saveFile} sx={{height:"35px"}}>
                            Guardar</Button>
                        </Box>

                        {invalido && <Alert severity="info">Debe Seleccionar un archivo</Alert>}
                        {exceso_size && <Alert severity="warning">Ningún Archivo puede exceder los 50MB</Alert>}
                </Paper>
            </Modal>

            {isCharging && <Loader />}
        </>
    );
}

export default Descargas;